import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import Header from "./commoncomponents/Header";
import Footer from "./commoncomponents/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Faq from "./pages/Faq";
import Services from "./pages/Services";
import Information from "./pages/Information";
import ContactUs from "./pages/Contact";

function App() {
  const location = useLocation();

  // 🔽 Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // 🔽 Initialize AOS once
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true, // Only animate once
    });
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Header />
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/services/:serviceType/:subServiceType?"
            element={<Services />}
          />
          <Route path="/information/:topic" element={<Information />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
